import { render } from "./JobTemplateDetails.vue?vue&type=template&id=32c2a30e&scoped=true"
import script from "./JobTemplateDetails.vue?vue&type=script&lang=js"
export * from "./JobTemplateDetails.vue?vue&type=script&lang=js"

import "./JobTemplateDetails.vue?vue&type=style&index=0&id=32c2a30e&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c2a30e"]])

export default __exports__